/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class InternalRecommenderAPI
 * @hideconstructor
 * @classdesc
 */
define([], () => {
	class InternalRecommenderAPI {
		/**
		 * @public
		 * @function InternalRecommenderAPI#getChartTypeList
		 * @description provides the list of available chart types
		 * @return {String[]} array of chart types
		*/
		getChartTypeList() { }
	}

	return InternalRecommenderAPI;
});
